import Animator from './Animator';

export default class TabAnimator extends Animator {
    constructor(configurations, dom) {
        super(configurations, dom);
    }

    animate(options) {
        const me = this;
        function chatTabSlide(direction) {
            if (me.shown) {
                ApexChat.animate(
                    document.getElementById(options.element),
                    `${direction}: -${me.configuration.chatTab.height}`,
                    {
                        duration: 1000
                    }
                );
                me.shown = false;
            } else {
                ApexChat.animate(document.getElementById(options.element), `${direction}: 0px`, {
                    duration: 1000
                });
                me.shown = true;
            }
        }
        function chatTabBlink() {
            if (me.shown) {
                document.getElementById(options.element).style.display = 'none';
                me.shown = false;
            } else {
                me.document.getElementById(options.element).style.display = 'block';
                me.shown = true;
            }
        }
        if (
            me.configuration.chatTab.chatTabAnimate == 'Blink' &&
            me.configuration.chatTab.chatTabTimer != 0
        ) {
            me.shown = true;

            setInterval(chatTabBlink, me.configuration.chatTab.chatTabTimer * 1000);
        }
        // summary: Due to RESET CSS the animation was not working because earlier version was using IN-Line CSS and now recently chat_tab.css was introduced so Sliding animation can only play via JS version
        if (
            me.configuration.chatTab.chatTabAnimate.indexOf('Slide') != -1 &&
            me.configuration.chatTab.chatTabTimer != 0
        ) {
            const chatTabDirection = me.configuration.chatTab.chatTabAnimate.replace('Slide', '');
            me.shown = true;

            setInterval(() => {
                chatTabSlide(chatTabDirection.toLowerCase());
            }, me.configuration.chatTab.chatTabTimer * 1000);
        }
    }
}
